import { IfAbility } from '@efdigital/ll-addon-auth';
import { Heading } from '@efdigital/ll-addon-ui';
import { EnrolledCoachees } from '@efdigital/ll-admin-v2/components/coaching/enrolled-coachees.gts';
import type { ModelFrom } from '@efdigital/ll-admin-v2/lib/type-utils';
import type ProgramsProgramCohortCoachingCoacheesRoute from '@efdigital/ll-admin-v2/routes/programs/program/cohort/coaching/coachees';
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';
import { pageTitle } from 'ember-page-title';

interface CoacheesSignature {
  Args: {
    model: ModelFrom<ProgramsProgramCohortCoachingCoacheesRoute>;
    controller: unknown;
  };
}

const ProgramsProgramCohortCoachingCoacheesTemplate: TemplateOnlyComponent<CoacheesSignature> =
  <template>
    {{pageTitle "Enrolled coachees"}}
    <div class="container py-5">
      <IfAbility @ability="coaching" @atLeast="viewer">
        <:if>
          <div class="row g-4">
            <div class="col-lg-10 col-xl-8 mx-auto">
              <LinkTo
                @route="programs.program.cohort.coaching"
                class="btn btn-link p-0 text-decoration-none mb-3 d-inline-flex align-items-center gap-1"
              >
                ← Back to coaching
              </LinkTo>

              <Heading @text="Enrolled coachees" />
              <p class="text-muted mb-4">Coach partnerships, session history,
                and best-matched coaches for each coachee in this cohort.</p>

              {{#if @model.coaching}}
                <EnrolledCoachees
                  @coaching={{@model.coaching}}
                  @cohortId={{@model.cohortId}}
                />
              {{else}}
                <p class="text-muted">Coaching has not been set up for this
                  cohort yet.</p>
              {{/if}}
            </div>
          </div>
        </:if>
        <:else>
          <div class="alert alert-warning" role="alert">
            <h4 class="alert-heading">Access Denied</h4>
            <p>You do not have permission to view coaching.</p>
            <p class="mb-0">Please contact your administrator if you believe you
              should have access.</p>
          </div>
        </:else>
      </IfAbility>
    </div>
  </template>;

export default ProgramsProgramCohortCoachingCoacheesTemplate;
